import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowRightIcon } from '@heroicons/react/24/solid'
import { LiveDemo } from './LiveDemo'
import { SPORTS } from '../content/sports'
import { RegisterModal } from '@components/registration/RegisterModal'

export function Hero() {
  const [showRegister, setShowRegister] = useState(false)

  return (
    <section className="relative overflow-hidden">
      {/* Subtle indigo glow behind the hero */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_50%_at_50%_0%,rgba(99,102,241,0.14),transparent_70%)]"
      />

      <div className="relative mx-auto max-w-7xl px-4 pb-16 pt-16 sm:px-6 sm:pt-20 lg:px-8 lg:pb-24 lg:pt-28">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          {/* Left: value prop */}
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-dash-border bg-dash-surface px-3 py-1 text-xs font-medium text-dash-secondary">
              <span className="h-1.5 w-1.5 rounded-full bg-dash-accent" />
              Sports entity resolution API
            </span>

            <h1 className="mt-5 text-4xl font-extrabold leading-[1.1] tracking-tight text-dash-text sm:text-5xl lg:text-6xl">
              One API. Every sportsbook{' '}
              <span className="bg-gradient-to-r from-dash-accent to-dash-accent-2 bg-clip-text text-transparent">
                speaks the same language.
              </span>
            </h1>

            <p className="mt-6 max-w-xl text-lg leading-relaxed text-dash-secondary">
              SportsMeld resolves teams and players across data sources so{' '}
              <span className="font-mono text-dash-text">&ldquo;Man Utd&rdquo;</span>,{' '}
              <span className="font-mono text-dash-text">&ldquo;Man United&rdquo;</span> and{' '}
              <span className="font-mono text-dash-text">&ldquo;Manchester United&rdquo;</span> all
              match &mdash; while Manchester United stays distinct from Manchester City. A 5-stage ML
              pipeline, with cached lookups in sub-millisecond time.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <button
                type="button"
                onClick={() => setShowRegister(true)}
                className="inline-flex animate-pulse-glow items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-dash-accent to-dash-accent-2 px-6 py-3 text-base font-semibold text-white shadow-sm transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-dash-accent focus-visible:ring-offset-2 focus-visible:ring-offset-dash-bg"
              >
                Get API key
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
              </button>
              <Link
                to="/docs"
                className="inline-flex items-center justify-center rounded-lg border border-dash-border px-6 py-3 text-base font-semibold text-dash-text transition-colors hover:bg-dash-surface focus:outline-none focus-visible:ring-2 focus-visible:ring-dash-accent"
              >
                Read the docs
              </Link>
            </div>

            {/* Trust strip */}
            <div className="mt-10">
              <div className="flex flex-wrap gap-2">
                {SPORTS.map((s) => (
                  <span
                    key={s.id}
                    className="rounded-md border border-dash-border bg-dash-surface px-2.5 py-1 text-xs text-dash-secondary"
                  >
                    {s.label}
                  </span>
                ))}
              </div>
              <div className="mt-5 flex flex-wrap items-center gap-x-8 gap-y-2 text-sm text-dash-secondary">
                <span>
                  <span className="font-mono font-semibold text-dash-text tabular-nums">1M+</span> pairs
                  matched
                </span>
                <span>
                  <span className="font-mono font-semibold text-dash-text tabular-nums">99%+</span>{' '}
                  precision
                </span>
                <span>
                  <span className="font-mono font-semibold text-dash-text tabular-nums">8</span> sports
                </span>
              </div>
            </div>
          </div>

          {/* Right: live demo */}
          <div id="demo" className="scroll-mt-24">
            <LiveDemo />
          </div>
        </div>
      </div>

      {showRegister && <RegisterModal onClose={() => setShowRegister(false)} redirectTo="/admin" />}
    </section>
  )
}
